import React from 'react';
import { IconProps } from './types';

export const TrashIcon = ({ className }: IconProps) => {
  return (
    <svg
      data-name="Laag 2"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 30 30"
    >
      <path d="M6,29H24V7H6ZM8,9H22V27H8Z" />
      <path d="M24,3.47H19.75V2.73A2.38,2.38,0,0,0,17.38.36h-4.8a2.38,2.38,0,0,0-2.37,2.37v.74H6a1,1,0,0,0,0,2H24a1,1,0,1,0,0-2ZM12.21,2.73a.37.37,0,0,1,.37-.37h4.8a.38.38,0,0,1,.37.37v.74H12.21Z" />
      <path d="M11.35,11a1,1,0,0,0-1,1V24.5a1,1,0,0,0,2,0V12A1,1,0,0,0,11.35,11Z" />
      <path d="M15.09,11a1,1,0,0,0-1,1V24.5a1,1,0,0,0,2,0V12A1,1,0,0,0,15.09,11Z" />
      <path d="M18.6,11a1,1,0,0,0-1,1V24.5a1,1,0,0,0,2,0V12A1,1,0,0,0,18.6,11Z" />
    </svg>
  );
};
